import * as React from "react";
import { useState } from "react";
import { useIntl } from "react-intl";
import classnames from "classnames";
import Button from "msem-lib/es/components/button";
import IntegerPicker from "msem-lib/es/components/integer-picker";
import SelectField from "../select-field";
import css from "./pax-plan-form.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Ages = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
const PaxPlanForm = ({
  onValidate,
  adults,
  children,
  agesChildren,
  compact = false
}) => {
  const intl = useIntl();
  const [selectedAdults, setAdults] = useState(adults || 0);
  const [selectedChildren, setChildren] = useState(children || 0);
  const [selectedChildrenAges, setChildrenAges] = useState(agesChildren || []);
  const changeAdults = val => {
    setAdults(val);
  };
  const changeChildren = val => {
    const oldVal = selectedChildren;
    const ages = val > oldVal ? [...selectedChildrenAges, 12] : selectedChildrenAges.slice(0, selectedChildrenAges.length - 1);
    setChildren(val);
    setChildrenAges(ages);
  };
  const changeAgeChildren = index => e => {
    const value = e.target.value;
    const ages = [...selectedChildrenAges.slice(0, index), parseInt(value, 10), ...selectedChildrenAges.slice(index + 1)];
    setChildrenAges(ages);
  };
  return _jsxs(_Fragment, {
    children: [_jsx("div", {
      className: classnames(css.paxPlan, {
        [css.compact]: compact
      }),
      children: _jsxs("div", {
        className: css.content,
        children: [_jsxs("div", {
          className: css.adults,
          children: [_jsx(IntegerPicker, {
            min: 0,
            max: 20,
            value: selectedAdults,
            onChange: changeAdults
          }), _jsx("div", {
            className: css.label,
            children: intl.messages.paxPlanFormAdults
          })]
        }), _jsxs("div", {
          children: [_jsxs("div", {
            className: css.children,
            children: [_jsx(IntegerPicker, {
              min: 0,
              max: 9,
              value: selectedChildren,
              onChange: changeChildren
            }), _jsx("div", {
              className: css.label,
              children: intl.messages.paxPlanFormChildren
            })]
          }), selectedChildren > 0 ? _jsx("div", {
            className: css.childrenSuffix,
            children: intl.messages.paxPlanFormChildrenSuffix
          }) : null, selectedChildrenAges.map((age, index) => _jsxs("div", {
            className: css.ageRow,
            children: [_jsx("div", {
              className: css.ageRowLabel,
              children: intl.formatMessage({
                id: "paxPlanFormChildrenCount"
              }, {
                count: index + 1
              })
            }), _jsx("div", {
              className: css.select,
              children: _jsx(SelectField, {
                value: age,
                onChange: changeAgeChildren(index),
                children: Ages.map((option, idx) => _jsx("option", {
                  value: option,
                  children: intl.formatMessage({
                    id: "paxPlanFormChildrenAge"
                  }, {
                    count: option
                  })
                }, idx))
              })
            })]
          }, index))]
        })]
      })
    }), _jsx(Button, {
      tag: "a",
      onClick: onValidate({
        adults: selectedAdults,
        children: selectedChildren,
        agesChildren: selectedChildrenAges
      }),
      contained: true,
      children: intl.messages.validate
    })]
  });
};
export default PaxPlanForm;